import React from "react";
import { FiUsers } from "react-icons/fi";

const NoLeadsScreen = ({ isFiltered = false, onReset }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 bg-background.DEFAULT rounded-lg shadow-sm border border-border font-poppins">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-5">
        <FiUsers className="w-10 h-10" />
      </div>

      <h2 className="text-2xl font-semibold text-text.primary mb-2">
        {isFiltered ? "No Matching Leads" : "No Leads Yet"}
      </h2>

      <p className="text-text.secondary text-sm sm:text-base mb-6 max-w-md">
        {isFiltered
          ? "Try adjusting your filters or search terms to find matching leads."
          : "Once people start showing interest in your properties, their details will show up here."}
      </p>

      <button
        onClick={onReset || (() => window.location.reload())}
        className="px-6 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-primary/90 transition-all duration-200 shadow-sm"
      >
        {isFiltered ? "Clear Filters" : "Refresh"}
      </button>
    </div>
  );
};

export default NoLeadsScreen;
